// libs
import React from 'react';

// components
import PersonalDetails from './PersonalDetails';
import MembershipDetails from './MembershipDetails';
import MemberAlerts from './MemberAlerts';
import CommentsSection from "./CommentsSection";
import AuthService from '../../../../../services/AuthService';

const MemberSection = (props) => {
    const {
        member,
        isResendCardEnabled,
        onPressResendCard,
        isLoadingResendCard,
        resendCardResult,
        resendCardError,
        onSaveComment,
        onDeleteComment,
        isLoadingComment,
        deleteAccount,
        handleButtonNameChange,
        buttonName,
        disableButton,
        toApiLogs
    } = props;

    if (!member) {
        return null;
    }

    const handleSync = () => {
        props.sync(member.futuraCustomerId);
    }

    return (
        
        <div>
            <MemberAlerts 
                member={member} 
                toApiLogs={toApiLogs}
            /><br />
            {AuthService.can('sync futura customer') &&
                <div className="col">
                    <button className="btn btn--small btn--color" style={{ float: 'right' }} onClick={handleSync}>Sync</button>
                </div>
            }
            <div className="info-wrap margin--40--top col-2 gutter--40">
                <div className="col">
                    <PersonalDetails 
                        member={member} 
                        deleteAccount={deleteAccount} 
                        handleButtonNameChange={handleButtonNameChange} 
                        buttonName={buttonName} 
                        disableButton={disableButton}
                    />
                    <MembershipDetails
                        member={member}
                        isResendCardEnabled={isResendCardEnabled}
                        onPressResendCard={onPressResendCard}
                        isLoadingResendCard={isLoadingResendCard}
                        resendCardResult={resendCardResult}
                        resendCardError={resendCardError}
                    />
                    <CommentsSection comments={member.comments} onSave={onSaveComment} onDelete={onDeleteComment} isLoading={isLoadingComment} />
                </div>
                {props.children}
            </div>
        </div>
    );
};

export default MemberSection;
